<script>
    import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "@sveltestrap/sveltestrap";
    import Help from "../snippets/Help.svelte";
    import ButtonLine from "../snippets/ButtonLine.svelte";
    import {focusLastModalElement, handleStaticModalToggle, modalClassName, modalFade} from "./utils.js";

    let {
        showConfirm = $bindable(false),
        title = 'Sicherheitsabfrage',
        confirmLabel = 'OK',
        cancelLabel = null,
        helpUrl = null,
        confirm,
        cancel,
        header,
        children,
        ...rest
    } = $props();

    const toggle = () => (showConfirm = !showConfirm);

    const handleConfirm = () => {
        toggle();
        confirm?.(true);
    };

    const handleCancel = () => {
        toggle();
        cancel?.(false);
    };

    function defaultClosing() {
        if (cancelLabel) {
            handleCancel();
        } else {
            handleConfirm();
        }
    }

    const handleModalToggle = handleStaticModalToggle(defaultClosing);
</script>

<Modal 
    {...rest}
    isOpen={showConfirm}
    toggle={handleModalToggle}
    fade={$modalFade}
    modalClassName={$modalClassName}
    on:open={() => focusLastModalElement(".modal .confirm-button")}
>
    <ModalHeader toggle={handleModalToggle}>
        {#if header}
            {@render header()}
        {:else}
            {title}
        {/if}
    </ModalHeader>

    <ModalBody>
        {@render children?.()}
    </ModalBody>

    <ModalFooter>
        <ButtonLine>
            {#if helpUrl}
                {#snippet left()}
                    <Help url={helpUrl} />
                {/snippet}
            {/if}

            {#if cancelLabel}
                <Button color="primary" on:click={handleCancel} data-test-name="cancel">
                    {cancelLabel}
                </Button>
            {/if}

            <Button color="primary" class="confirm-button" on:click={handleConfirm} data-test-name="confirm">
                {confirmLabel}
            </Button>
        </ButtonLine>
    </ModalFooter>
</Modal>
